import React from 'react';
import { domToReact } from 'html-react-parser';
import { AccordionList } from '@cdm/quickenloans-library/lib';
import {
    wpFAQClass,
    wpFAQSectionClass,
    wpFAQQuestionClass,
    wpFAQAnswerClass,
    testAttributes,
} from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const classIncludes = (classHaystack, classNeedle) =>
    classHaystack?.split(' ').includes(classNeedle);

const extractSectionElements = (sectionChildren, replaceFn) => 
{
    const sectionExtracts = {
        question: '',
        answer: '',
    };
    const children = sectionChildren.filter((child) => child.type === 'tag');
    children.forEach((child) => 
    {
        if (classIncludes(child?.attribs?.class, wpFAQQuestionClass)) 
        {
            sectionExtracts.question = domToReact(child.children, replaceFn());
        }
        if (classIncludes(child?.attribs?.class, wpFAQAnswerClass)) 
        {
            sectionExtracts.answer = domToReact(child.children, replaceFn());
        }
    });

    return sectionExtracts;
};

const toFAQ = (parserData) => 
{
    const {parserOptions: { replaceFn }} = parserData;
    const Wrapper = ({
        name = parserPropTypesDefaults.name,
        type = parserPropTypesDefaults.type,
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children,
    }) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        if (!attribs?.class) return null;
        if (!classIncludes(attribs.class, wpFAQClass)) return null;
        if (!children || !Array.isArray(children)) return null;

        const sectionChildren = children.filter(
            (child) =>
                child.type === 'tag' &&
                child.attribs.class === wpFAQSectionClass
        );
        if (sectionChildren.length === 0) return null;

        const faqs = sectionChildren.map((sectionChild) => 
        {
            const { question, answer } = extractSectionElements(
                sectionChild.children,
                replaceFn
            );
            const { id } = sectionChild.attribs;
            return (
                <AccordionList
                    key={id}
                    as="postfixList"
                    title={question}
                    defaultExpanded={false}
                    variation="secondary"
                    testId={testAttributes.FAQ_ACCORDION_TITLE}
                >
                    {answer}
                </AccordionList>
            );
        });

        return (
            <div
                data-testid={testAttributes.FAQ_ACCORDION_CARD_CONTAINER}
                className={testAttributes.FAQ_ACCORDION_CARD_CONTAINER}
            >
                {faqs}
            </div>
        );
    };
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
};

export default toFAQ;
